import React from 'react';
import { useSearchBarContext } from './Context/SearchBarContext';
import { ESearchBarStatus } from './Context/types';
import { Spinner } from 'react-bootstrap';
import FmlxBaseIcon from '@fmlx/icons/FmlxBaseIcon';
import { ReactComponent as NoResults } from '../../../../Icon/Search/NoResults.svg';

export const ExplorerSearchStatus = () => {
  const { explorerStatus: status } = useSearchBarContext();

  return status == ESearchBarStatus.NoResults ? (
    <div className="flex flex-col gap-2 w-full h-full items-center justify-center">
      <FmlxBaseIcon glyph={<NoResults />} customSize={26} />
      <div className="font-[Roboto] text-[#5D5D5D]">Result Not Found</div>
    </div>
  ) : (
    <div
      id="projectdashboard-search-loading"
      className="flex flex-col gap-2 w-full h-full items-center justify-center"
    >
      <Spinner
        id="loading-modal-spinner-border"
        animation="border"
        className="text-[#F89723] w-8 h-8 shrink-0"
      />
      <div className="font-[Roboto] text-[#5D5D5D]">Loading search result</div>
    </div>
  );
};
